// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box, useTheme } from '@mui/system';
import { Link, Typography } from '@mui/material';
import { formatPromotionWindow } from 'Utils/promotion';
import stylesDef from './styles';

interface PromotionBannerProps {
  promotion: IPromotionInfo;
  variant: 'page' | 'card';
  dateFormat: string;
}

// Every word comes from the promotion document: the verbatim headline when one is set, otherwise the
// label with the window formatted per bound; then the body copy and an optional link.
export const PromotionBanner = ({ promotion, variant, dateFormat }: PromotionBannerProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const headline = promotion.bannerHeadline || `${promotion.displayText} · ${formatPromotionWindow(promotion, dateFormat)}`;
  const hasBody = Boolean(promotion.bannerText || promotion.bannerLink);

  return (
    <Box sx={[styles.banner, variant === 'page' ? styles.page : styles.card]}>
      <Typography sx={styles.headline}>{headline}</Typography>
      {hasBody && (
        <Typography sx={styles.body}>
          {promotion.bannerText}
          {promotion.bannerText && promotion.bannerLink ? ' ' : ''}
          {promotion.bannerLink && (
            <Link href={promotion.bannerLink.url} target="_blank" rel="noopener noreferrer" sx={styles.link}>
              {promotion.bannerLink.text}
            </Link>
          )}
        </Typography>
      )}
    </Box>
  );
};

export default PromotionBanner;
